export default __webpack_public_path__ + "static/media/bell_normal.46b045aa.svg";